"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormMessage = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _excluded = ["text", "type"];
var FormMessage = exports.FormMessage = function FormMessage(_ref) {
  var _typeColorMap$type;
  var text = _ref.text,
    type = _ref.type,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var typeColorMap = {
    error: 'danger',
    info: '',
    success: 'success'
  };
  return _react["default"].createElement(_reactstrap.FormText, (0, _extends2["default"])({
    color: (_typeColorMap$type = typeColorMap[type]) !== null && _typeColorMap$type !== void 0 ? _typeColorMap$type : ''
  }, props), text);
};
FormMessage.propTypes = {
  text: _propTypes["default"].string.isRequired || _propTypes["default"].node.isRequired,
  type: _propTypes["default"].oneOf(['error', 'info', 'success']),
  ariaLabel: _propTypes["default"].string
};